import { render, staticRenderFns } from "./vNewUser.vue?vue&type=template&id=36c052ca&"
import script from "./vNewUser.vue?vue&type=script&lang=js&"
export * from "./vNewUser.vue?vue&type=script&lang=js&"
import style0 from "./vNewUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports